import { Box, IconButton } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import lineSightLogo from 'assets/img/linesight_logo_white_purp.png';
import UserAvatar from 'components/common/users/profile/user-avatar';
import { useAuth } from 'contexts/auth-context';
import { APP_HEADER_HEIGHT } from 'lib/constants/app';
import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import UserMenu from './user-menu';
import IconBreadcrumbs from './icon-breadcrumbs';

const avatarProps = {
  sx: {
    width: '3rem',
    height: '3rem'
  }
};

const Header = () => {
  const { user, signOut } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  // signout btn and avatar in navbar
  const handleUserMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuNav = (location) => {
    navigate(`/admin/${location}`);
    handleClose();
  };

  return (
    <AppBar position="sticky" sx={{ height: APP_HEADER_HEIGHT }}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <NavLink to="/" style={{ textDecoration: 'none' }}>
            <img
              src={lineSightLogo}
              alt="scryb logo"
              style={{ width: '8rem', marginRight: '0.5rem', paddingTop: '0.35rem' }}
            />
          </NavLink>
          <IconBreadcrumbs />
        </Box>
        {user?.email && user?.token && (
          <>
            <IconButton sx={{ p: 0 }} onClick={handleUserMenuClick}>
              <UserAvatar
                firstName={user.name?.split(' ')[0]}
                lastName={user.name?.split(' ')[1]}
                color={user.color}
                avatarProps={avatarProps}
              />
            </IconButton>

            <UserMenu
              anchorEl={anchorEl}
              onClose={handleClose}
              user={user}
              onLogout={() => signOut(false)}
              onMenuNav={handleMenuNav}
            />
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
